const t = (label, o = {}) => ({ type: 'text', label, ...o });
const ta = (label, o = {}) => ({ type: 'textarea', label, ...o });
const r = (label, options, o = {}) => ({ type: 'radio', label, options, ...o });
const c = (label, options, o = {}) => ({ type: 'checkbox', label, options, ...o });
const f = (label, o = {}) => ({ type: 'file', label, ...o });
const note = (label) => ({ type: 'note', label });
const req = { required: true };

const FLEX = ['Confirmée', 'Flexible'];
const flex = (label) => r(label, FLEX, { share: 'flex' });
const CONTACT_PREF = ['E-mail', 'Téléphone', 'WhatsApp'];
const BUDGET = ['1 500 à 3 000 €', '3 000 à 5 000 €', '5 000 à 10 000 €', '10 000 à 20 000 €', 'Plus de 20 000 €'];
const EXACT = 'Je confirme que les informations communiquées sont exactes.';
const NO_DISPO = 'Je comprends que l’envoi du formulaire ne confirme pas la disponibilité de JBMH Events à la date indiquée.';
const CONSENT = 'J’accepte d’être contacté(e) par JBMH Events dans le cadre de ma demande.';
const consent = (label, required = true) => ({ type: 'consent', label, required });

export const INITIAL_FORM = {
  type: 'initial',
  title: 'Parlez-nous de votre projet',
  intro: 'Ces premières informations nous permettront d’identifier votre univers et de vous adresser le questionnaire détaillé correspondant à votre demande.',
  sections: [
    { title: 'Vos coordonnées', fields: [
      t('Nom et prénom', { ...req, role: 'name' }),
      t('Adresse e-mail', { ...req, input: 'email', role: 'email' }),
      t('Numéro de téléphone', { ...req, input: 'tel', role: 'phone' }),
      t('Ville et pays de résidence', { ...req, share: 'city' }),
    ] },
    { title: 'Votre événement', fields: [
      { type: 'universe', label: 'Quel univers souhaitez-vous nous confier ?', options: ['Wedding', 'Réception privée', 'Corporate ou marque', 'JBMH Héritage'], required: true, role: 'eventType', error: 'Veuillez sélectionner le type d’événement.' },
      t('Date prévue', { ...req, input: 'date', role: 'date' }),
      flex('La date est-elle confirmée ou flexible ?'),
      t('Lieu de l’événement : nom du lieu, ville et pays', { role: 'location' }),
      t('Nombre approximatif d’invités', { role: 'guests' }),
      ta('Présentez-nous votre projet en quelques lignes', { ...req, role: 'message' }),
      r('Moyen de contact privilégié', CONTACT_PREF, { share: 'contact' }),
      consent(CONSENT),
    ] },
  ],
};

export const QUESTIONNAIRES = {
  weddings: {
    type: 'weddings',
    eventType: 'Wedding',
    title: 'Confiez-nous votre mariage',
    intro: 'Chaque mariage mérite une conception singulière, fidèle à votre histoire et à ce que vous souhaitez faire vivre à vos invités.\nÀ travers ce questionnaire, partagez-nous les éléments essentiels de votre projet. Ils nous permettront de comprendre vos attentes et d’imaginer un accompagnement à votre mesure.',
    sections: [
      { title: '01 — Vos coordonnées', fields: [
        t('Vos noms et prénoms', { ...req, role: 'name' }),
        t('Adresse e-mail', { ...req, input: 'email', role: 'email' }),
        t('Numéro de téléphone', { ...req, input: 'tel', role: 'phone' }),
        t('Ville et pays de résidence', { ...req, share: 'city' }),
        r('Moyen de contact privilégié', CONTACT_PREF, { share: 'contact' }),
      ] },
      { title: '02 — Votre mariage', fields: [
        t('Date prévue du mariage', { ...req, input: 'date', role: 'date' }),
        flex('La date est-elle confirmée ou flexible ?'),
        t('Nom du lieu, ville et pays', { role: 'location' }),
        r('Le lieu est-il déjà réservé ?', ['Oui', 'Non', 'Recherche en cours']),
        c('Type de lieu', ['Salle de réception', 'Château', 'Domaine', 'Hôtel', 'Villa ou propriété privée', 'Jardin ou espace extérieur', 'Autre']),
        r('Nombre d’invités', ['Moins de 50', '50 à 100', '101 à 150', '151 à 250', 'Plus de 250'], { role: 'guests' }),
        c('Moments prévus', ['Cérémonie', 'Cocktail', 'Dîner', 'Soirée', 'Brunch', 'Autre']),
      ] },
      { title: '03 — L’accompagnement souhaité', fields: [
        r('L’accompagnement souhaité', ['Scénographie & décoration', 'Scénographie, décoration & coordination du jour J', 'Organisation partielle', 'Organisation complète', 'Destination Wedding', 'Nous souhaitons être conseillés'], { hideLabel: true }),
      ] },
      { title: '04 — Vos prestataires', fields: [
        c('Prestataires déjà confirmés', ['Lieu', 'Traiteur', 'Photographe', 'Vidéaste', 'DJ ou musiciens', 'Fleuriste', 'Pâtissier', 'Officiant', 'Aucun', 'Autre']),
        ta('Souhaitez-vous être accompagnés dans la recherche de certains prestataires ?'),
      ] },
      { title: '05 — Votre scénographie', fields: [
        c('Espaces à mettre en scène', ['Cérémonie', 'Accueil', 'Cocktail', 'Salle de réception', 'Tables des invités', 'Table d’honneur', 'Espace photographique', 'Espace gâteau', 'Espace lounge', 'Autre']),
        c('Éléments souhaités', ['Compositions florales', 'Mobilier décoratif', 'Art de la table', 'Structures ou arches', 'Fond scénographique', 'Bougies et lumière', 'Papeterie et signalétique', 'Monogramme', 'Autre']),
        note('Les créations florales et les éléments scénographiques sont conçus comme les composantes d’un univers global. Ils ne sont pas proposés comme des prestations isolées.'),
      ] },
      { title: '06 — L’univers imaginé', fields: [
        ta('Comment décririez-vous l’atmosphère de votre mariage ?'),
        ta('Quelles émotions souhaitez-vous faire ressentir à vos invités ?'),
        r('Avez-vous choisi une palette de couleurs ?', ['Oui', 'Non', 'Conseil souhaité']),
        t('Couleurs envisagées'),
        t('Style floral souhaité'),
        t('Tenue de la mariée : couleur, coupe et détails'),
        t('Tenue du marié : couleur et style'),
        t('Tenues des demoiselles et garçons d’honneur : couleurs et orientations'),
        f('Téléversement : photographies, moodboard ou inspirations'),
        t('Lien Pinterest ou dossier d’inspiration'),
      ] },
      { title: '07 — Votre budget', hidden: true, fields: [
        r('Enveloppe consacrée aux prestations de JBMH Events', BUDGET),
        r('Cette enveloppe est-elle déterminée, approximative ou susceptible d’évoluer selon la proposition ?', ['Déterminée', 'Approximative', 'Susceptible d’évoluer']),
        t('Pour une organisation partielle ou complète : quel est le budget global envisagé pour le mariage ?'),
      ] },
      { title: '08 — Informations complémentaires', fields: [
        ta('Contraintes particulières : accès, stationnement, étage, horaires d’installation, restrictions techniques, traditions, exigences culturelles ou autres particularités'),
        ta('Souhaitez-vous ajouter une précision ?', { role: 'message' }),
        r('Comment avez-vous découvert JBMH Events ?', ['Instagram', 'TikTok', 'Recherche en ligne', 'Recommandation', 'Événement précédent', 'Autre']),
      ] },
      { title: 'Validation', fields: [consent(EXACT), consent(NO_DISPO, false), consent('Je comprends qu’une date est définitivement réservée après validation de la proposition, signature des documents contractuels et versement de l’acompte.', false), consent(CONSENT)] },
    ],
  },
  receptions: {
    type: 'receptions',
    title: 'Donnons forme à votre réception',
    intro: 'Dîner privé, anniversaire, gala ou événement d’entreprise : confiez-nous les contours de votre projet. Nous concevrons une atmosphère cohérente avec l’occasion, le lieu et l’expérience que vous souhaitez offrir.',
    sections: [
      { title: '01 — Vos coordonnées', fields: [
        r('Vous êtes', ['Particulier', 'Entreprise', 'Marque', 'Agence', 'Institution', 'Autre']),
        t('Nom et prénom de la personne de contact', { ...req, role: 'name' }),
        t('Nom de l’entreprise ou de la marque'),
        t('Fonction'),
        t('Adresse e-mail', { ...req, input: 'email', role: 'email' }),
        t('Numéro de téléphone', { ...req, input: 'tel', role: 'phone' }),
      ] },
      { title: '02 — Votre événement', fields: [
        r('Nature de l’événement', ['Dîner privé', 'Anniversaire', 'Baby shower', 'Célébration familiale', 'Gala', 'Dîner d’entreprise', 'Séminaire ou soirée d’équipe', 'Lancement de produit', 'Activation ou événement de marque', 'Inauguration', 'Autre'], { role: 'eventType' }),
        t('Date prévue', { ...req, input: 'date', role: 'date' }),
        flex('Date confirmée ou flexible'),
        r('Nombre estimé d’invités', ['Moins de 30', '30 à 50', '51 à 100', '101 à 200', 'Plus de 200'], { role: 'guests' }),
        t('Horaires envisagés'),
      ] },
      { title: '03 — Votre lieu', fields: [
        t('Nom et adresse du lieu', { role: 'location' }),
        c('Type de lieu', ['Résidence privée', 'Salle de réception', 'Restaurant', 'Hôtel', 'Château ou domaine', 'Rooftop', 'Boutique ou espace commercial', 'Siège d’entreprise', 'Espace extérieur', 'Lieu à rechercher', 'Autre']),
        r('Le lieu est-il définitivement réservé ?', ['Oui', 'Non', 'En attente']),
        f('Téléversement : photographies, plan ou vidéo du lieu', { video: true }),
      ] },
      { title: '04 — Votre accompagnement', fields: [
        r('Votre accompagnement', ['Scénographie & décoration', 'Scénographie, décoration & coordination', 'Organisation partielle', 'Organisation complète', 'Nous souhaitons être conseillés'], { hideLabel: true }),
      ] },
      { title: '05 — Votre scénographie', fields: [
        c('Espaces à mettre en scène', ['Entrée', 'Accueil', 'Cocktail', 'Salle', 'Tables', 'Espace photographique', 'Scène', 'Espace de prise de parole', 'Mise en valeur du produit ou de la marque', 'Lounge', 'Autre']),
        c('Éléments souhaités', ['Compositions florales', 'Mobilier', 'Décoration de table', 'Art de la table', 'Structures', 'Fonds scénographiques', 'Bougies', 'Lumière', 'Papeterie', 'Signalétique', 'Logo ou monogramme', 'Autre']),
      ] },
      { title: '06 — Votre univers', fields: [
        t('Atmosphère souhaitée'),
        t('Couleurs à privilégier'),
        t('Objectif principal de l’événement'),
        r('Pour une entreprise ou une marque : disposez-vous d’une charte graphique ?', ['Oui', 'Non', 'Non applicable']),
        f('Téléversement : logo, charte graphique, photographies ou inspirations'),
      ] },
      { title: '07 — Vos prestataires', fields: [
        c('Prestataires confirmés', ['Lieu', 'Traiteur', 'Photographe', 'Vidéaste', 'DJ ou musiciens', 'Animateur', 'Technique audiovisuelle', 'Sécurité', 'Aucun', 'Autre']),
        ta('Souhaitez-vous être accompagné dans la recherche de certains prestataires ?'),
      ] },
      { title: '08 — Votre budget', hidden: true, fields: [
        r('Enveloppe consacrée aux prestations de JBMH Events', BUDGET),
        r('Cette enveloppe est-elle déterminée, approximative ou susceptible d’évoluer ?', ['Déterminée', 'Approximative', 'Susceptible d’évoluer']),
      ] },
      { title: '09 — Informations complémentaires', fields: [
        t('Heure d’accès au lieu pour l’installation'),
        ta('Contraintes particulières : accès, stationnement, étage, sécurité, horaires ou restrictions techniques'),
        ta('Précision supplémentaire', { role: 'message' }),
      ] },
      { title: 'Validation', fields: [consent(EXACT), consent(NO_DISPO, false), consent('Je comprends que la date est définitivement réservée après validation de la proposition, signature des documents contractuels et versement de l’acompte.', false), consent(CONSENT)] },
    ],
  },
  heritage: {
    type: 'heritage',
    title: 'Célébrons votre héritage',
    intro: 'Partagez-nous les informations essentielles de votre Henna Time ou de votre célébration traditionnelle afin que nous puissions vous orienter vers la formule la plus adaptée.',
    sections: [
      { title: '01 — Vos coordonnées', fields: [
        t('Nom et prénom', { ...req, role: 'name' }),
        t('Adresse e-mail', { ...req, input: 'email', role: 'email' }),
        t('Numéro de téléphone', { ...req, input: 'tel', role: 'phone' }),
        t('Ville et pays de résidence', { ...req, share: 'city' }),
      ] },
      { title: '02 — Votre célébration', fields: [
        r('Type d’événement', ['Henna Time', 'Cérémonie traditionnelle', 'Célébration prénuptiale', 'Autre'], { role: 'eventType' }),
        t('Date prévue', { ...req, input: 'date', role: 'date' }),
        flex('Date confirmée ou flexible'),
        r('Formule souhaitée', ['Henna Time Simple', 'Henna Time Premium', 'Deco traditionnel simple', 'Premium', 'Conseil souhaité']),
      ] },
      { title: '03 — Nombre de personnes', fields: [
        r('Nombre de participants', ['1 à 12', '13 à 14', '15 à 20', '21 à 25', '26 à 30', 'Plus de 30', 'Autre'], { role: 'guests' }),
        note('Le tarif est déterminé selon le nombre de personnes, la formule choisie et le niveau de personnalisation souhaité.'),
      ] },
      { title: '04 — Votre lieu', fields: [
        t('Nom et adresse complète du lieu', { ...req, role: 'location' }),
        r('Type de lieu', ['Appartement', 'Maison', 'Salle de réception', 'Hôtel', 'Villa', 'Jardin ou espace extérieur', 'Autre']),
        r('Le lieu se situe-t-il à l’étage ?', ['Non', 'Oui avec ascenseur', 'Oui sans ascenseur']),
        r('Un stationnement est-il disponible à proximité immédiate ?', ['Oui', 'Non', 'À confirmer']),
        t('Heure d’accès au lieu pour l’installation'),
        note('Une installation simple nécessite au minimum trois heures d’accès au lieu avant le début de la célébration.'),
        f('Téléversement obligatoire : vidéo récente et complète de l’espace à décorer', { ...req, video: true, videoOnly: true }),
      ] },
      { title: '05 — Votre univers', fields: [
        t('Couleurs souhaitées', req),
        t('Couleurs et style de la tenue principale'),
        r('Style imaginé', ['Traditionnel', 'Élégant et épuré', 'Riche et coloré', 'Contemporain', 'Conseil souhaité', 'Autre']),
        r('Souhaitez-vous intégrer des objets, textiles ou éléments issus de votre culture ou de votre famille ?', ['Oui', 'Non']),
        t('Si oui, lesquels ?'),
        f('Téléversement : photographies ou inspirations'),
      ] },
      { title: '06 — Éléments complémentaires', fields: [
        c('Éléments complémentaires', ['Coussins et assises supplémentaires', 'Tapis supplémentaires', 'Chaise traditionnelle', 'Éléments personnalisés', 'Autre'], { hideLabel: true }),
        note('Les éléments inclus sont adaptés à la formule choisie, au nombre de personnes et aux caractéristiques du lieu.'),
      ] },
      { title: '07 — Informations complémentaires', fields: [
        ta('Difficultés d’accès ou contraintes particulières : escaliers, stationnement, horaires imposés, passage étroit ou mobilier présent'),
        ta('Précision supplémentaire', { role: 'message' }),
      ] },
      { title: 'Validation', fields: [consent(EXACT), consent(NO_DISPO, false), consent('Je comprends que la date est définitivement réservée après validation de la proposition, signature des documents contractuels et versement de l’acompte.', false), consent('Je m’engage à transmettre une vidéo récente et complète du lieu avant l’établissement définitif de la proposition.', false), consent(CONSENT)] },
    ],
  },
};

// /devis only: Section 09 fields missing from each detailed questionnaire, inserted in logical position
const PROJECT = ta('Présentez-nous votre projet en quelques lignes', { ...req, role: 'message', share: 'project' });
const CITY = t('Ville et pays de résidence', { ...req, share: 'city' });
const CONTACT = r('Moyen de contact privilégié', CONTACT_PREF, { share: 'contact' });
const insertAfter = (fields, label, ...extra) => {
  const i = fields.findIndex((x) => x.label === label) + 1;
  return [...fields.slice(0, i), ...extra, ...fields.slice(i)];
};
const unrole = (fl) => (fl.role === 'message' ? { ...fl, role: undefined } : fl);
const extend = (def, patches) => ({
  ...def,
  variant: 'devis',
  sections: def.sections.map((s, si) => ({ ...s, fields: (patches[si] || ((x) => x))(s.fields.map(unrole)) })),
});

export const DEVIS_FORMS = {
  weddings: extend(QUESTIONNAIRES.weddings, { 1: (fs) => [...fs, PROJECT] }),
  receptions: extend(QUESTIONNAIRES.receptions, { 0: (fs) => insertAfter(fs, 'Numéro de téléphone', CITY, CONTACT), 1: (fs) => [...fs, PROJECT] }),
  heritage: extend(QUESTIONNAIRES.heritage, { 0: (fs) => [...fs, CONTACT], 1: (fs) => [...fs, PROJECT] }),
};

export const DEVIS_UNIVERSES = [
  { key: 'weddings', label: 'Weddings' },
  { key: 'receptions', label: 'Réceptions privées & Corporate' },
  { key: 'heritage', label: 'JBMH Héritage' },
];
